import React from 'react'

export default _ =>
  <div className='tl tc-ns pt5 pb4 pb3-ns ph4 ph2-m ph0-ns'>
    <h1 className='heading1 lh-solid'>SCIENCE EXPERIMENT</h1>
    <p className='info fos f6 f5-ns lh-copy mt4 mb4 ph0 ph6-ns'>Now that you've completed TAC's Road Smart Interactive Science Experiment, see your results and learn more about the effect of Speed and Friction.</p>
  </div>
